<template>
    <div>
        <Search @callback="handleSearchCallback" :page="page"></Search>
    
        <Group @callback="handleGroupCallback" @callbackReload="handleGroupCallbackReload" :page="page" :search="search" :listReload.sync="listReload"></Group>
    
        <List @callback="handleListCallback" :page="page" :search="search" :collectionId="collectionId" :reload.sync="reload"></List>
    </div>
</template>

<script>
import { getDate } from '@/common/utils';
// import Search from './components/Search';
import Search from './components/SearchBlocked';
import Group from './components/Group';
import List from './components/List';

export default {
    name: 'blocked',
    data() {
        return {
            page: 'blocked',
            search: {
                // date: [getDate(-1), getDate(-1)]
                // 已屏蔽默认选中今天
                date: [getDate(0), getDate(0)] 
            },
            listReload: false,
            collectionId: '',
            reload: false
        }
    },
    
    components: {
        Search,
        Group,
        List
    },
    
    methods: {
        handleSearchCallback(data) {
            this.search = {...data};
        },
        handleGroupCallback(data) {
            this.collectionId = data.collectionId;
        },
        handleGroupCallbackReload(data) {
            this.reload = data.reload;
        },
        handleListCallback(data) {
            if (data && data.scrollTop) {
                this.$emit('callback', { page: this.page, scrollTop: data.scrollTop })
            }
            if (data && data.listReload) {
                this.listReload = true;
            }
        }
    },
    
    mounted() {
    }
}
</script>
